import React, {useState} from "react";
import Card from "@mui/material/Card";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import moment from "moment/moment";
import {onErrorAlert, onSuccessAlert} from "../../actions";
import {useDispatch} from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";

const CarriersInformation = ({info = {},loading}) => {
    const [isOpen,setIsOpen] = useState(true)
    const dispatch = useDispatch()
    const {t} = useTranslation()
    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    return(<React.Fragment>
        <Card  sx={{minWidth: 250}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {t('InboundPage.Ship From Information')}
                </MDTypography>
                <IconButton size={'small'} disabled={loading} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen&& !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Carrier ID')}:
                                </MDTypography>
                                {info?.carrierId && info?.carrierId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.carrierId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.carrierId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Carrier Name')}:
                                </MDTypography>
                                {info?.carrierName && info?.carrierName!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.carrierName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.carrierName}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('InboundPage.Carrier Order No.')}:
                                </MDTypography>
                                {info?.carrierOrderNo && info?.carrierOrderNo!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.carrierOrderNo)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.carrierOrderNo}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer ID')}:
                                </MDTypography>
                                {info?.customerId && info?.customerId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.customerId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerId}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Name')}:
                                </MDTypography>
                                {info?.customerName && info?.customerName!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.customerName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerName}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Customer Contact')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerContact}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Phone No.')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerPhone}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Email')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerEmail}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Address')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerAddress1}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Address 2')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerAddress2}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Province')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerProvince}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer City')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerCity}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Country')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerCountry}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Customer Zipcode')}
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.customerZipcode}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                    </Grid>
                </MDBox>
            </Collapse>

        </Card>
    </React.Fragment>)
}

export default CarriersInformation